import autoheight from '@/helpers/autoheight.coffee'
export default
  autoheight: (id)->
    if id == undefined
      autoheight.autoheightClass()
    else
      autoheight.autoheightId(id)
  autoheightClass: ->
    debug = false
    elements = document.getElementsByClassName('autoheight')
    elements = Array.from(elements)
    if debug
      console.info 'autoheight', 'elements', elements.length
    if elements.length < 0
      return
    elements.forEach (element, i) ->
      autoheight.autoheightElement(element)
  autoheightId: (id) ->
    element = document.getElementById(id)
    if element == undefined
      return
    if element == null
      return
    autoheight.autoheightElement(element)
  autoheightElement: (element) ->
    debug = false
    # Don't bother with invisible elements.
    if (element.offsetWidth <= 0 || element.offsetHeight <= 0)
      return
    elementStyle = window.getComputedStyle(element)
    elementHeight = elementStyle.getPropertyValue('height')
    if debug
      console.info 'elementHeight: ' + elementHeight
    # get element height, unit
    elementHeightFloat = parseFloat(elementHeight)
    if debug
      console.info 'heightFloat: ' + elementHeightFloat
    elementHeightUnit = elementHeight.replace(elementHeightFloat, '')
    if debug
      console.info 'elementHeightUnit: ' + elementHeightUnit
    # get parent element height
    parentHeight = autoheight.getParentHeight(element)
    # get sum of children of this parent heights.
    childrenHeight = autoheight.getChildrenHeight(element)
    # Set our height to parent height - that sum
    elementHeightNew = (parentHeight - childrenHeight) + '' + elementHeightUnit
    if debug
      console.info 'elementHeightNew: ' + elementHeightNew
    element.style.height = elementHeightNew
  getParentHeight: (element) ->
    debug = false
    # Get parent element
    parent = element.parentElement
    # set the parent to 100%, causes recompute of height
    parent.style.height = '100%'
    parentStyle = window.getComputedStyle(parent)
    parentheight = parentStyle.getPropertyValue('height')
    if debug
      console.info 'parentHeight: ' + parentheight
    parentHeightFloat = parseFloat(parentheight)
    if debug
      console.info 'parentHeightFloat: ' + parentHeightFloat
    parentHeightUnit = parentheight.replace(parentHeightFloat, '')
    if debug
      console.info 'parentHeightUnit: ' + parentHeightUnit
    return parentHeightFloat
  getChildrenHeight: (element) ->
    debug = false
    # Get parent element
    parent = element.parentElement
    # Get child elements
    children = parent.childNodes
    # Sum the heights of child elements other than this
    childrenheight = 0
    Array.from(children).forEach (child, v) ->
      if child != element
        childrenheight = childrenheight + parseFloat(autoheight.getChildHeight(child))
    if debug
      console.info 'childrenHeight: ' + childrenheight
    return childrenheight
  getChildHeight: (child) ->
    debug = false
    # Don't bother with invisible children.
    if (child.offsetWidth <= 0 || child.offsetHeight <= 0)
      return 0
    if child == undefined
      return 0
    if child.constructor.name == 'Comment'
      return 0
    if debug
      console.info 'child: ' + child.className
    if child.className == 'comment'
      return 0
    childheight = parseFloat(window.getComputedStyle(child).getPropertyValue('height'))
    if debug
      console.info 'childheight: ' + childheight
    return childheight
  enableAutoHeight: ->
    autoheight.autoheight()
    window.addEventListener 'resize', ->
      autoheight.autoheight()